import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import InventoryListTable from "../../components/inventories/inventoryListTable";
import { uploadedAuctionInvListRequest } from "../../store/actions/fetchAuctionUploadedInventoryListAction";
import Main from "../../components/main";
import ImageSlideModal from "../modal/imageSlideModal";
import ImageuploadModal from "../modal/imageUploadModal";
import SingleImageModal from "../modal/singleImageModal";

const NbfcInventoryList = () => {
	const [modalData, setModalData] = useState([]);
	const [imageData, setImageData] = useState([]);
	const [singleImage, setSingleImage] = useState("");
	const [imageSlideShow, setImageSlideShow] = useState(false);
	const [singleImageShow, setSingleImageShow] = useState(false);
	const [imageUploadModal, setImageUploadModal] = useState(false);
	const [multipleImageStatus, setMultipleImageStatus] = useState(false);

	const navigate = useNavigate();
	const params = useParams();
	const { auctionName, uplodedId } = params;
	const dispatch = useDispatch();
	const uploadedAuctionRes = useSelector(
		(state) => state.fetchAuctionUploadedInvListReducer
	);
	const { loading, uploadedAuctionInvResult } = uploadedAuctionRes;
	const loginObj = useSelector((state) => state.nbfcLoginReducer);
	const { loginResult } = loginObj;

	useEffect(() => {
		dispatch(
			uploadedAuctionInvListRequest({
				accessToken: loginResult?.access,
				auction_id: uplodedId,
			})
		);
	}, []);

	const viewBids = (productJson) => {
		navigate(`/viewbidstatus/${auctionName}/${productJson?.MAKE}/${productJson?.["MODEL system"]}/${uplodedId}/${productJson.id}`);
	};

	const uploadUpdateImages = (item, multipleStatus) => {
		setImageUploadModal((prev) => !prev);
		setMultipleImageStatus(multipleStatus);
		setModalData(item);
	};

	const viewThumbnail = (item) => {
		singleImageShowHandler(item);
	};

	const uploadUpdateThumbnail = (item, multipleStatus) => {
		uploadUpdateImages(item, multipleStatus);
	};

	const imageSlideShowHandler = (item) => {
		if (item?.metadata?.images) {
			setImageData(item?.metadata?.images);
		}
		setModalData(item);
		setImageSlideShow((prev) => !prev);
	};

	const singleImageShowHandler = (item) => {
		if (item?.metadata?.thumbnail_image) {
			setSingleImage(item?.metadata?.thumbnail_image);
		}
		setModalData(item);
		setSingleImageShow((prev) => !prev);
	};

	return (
		<Main>
			<InventoryListTable
				loading={loading}
				data={uploadedAuctionInvResult?.data}
				itemsPerPage="15"
				viewBids={viewBids}
				viewImages={imageSlideShowHandler}
				uploadUpdateImages={uploadUpdateImages}
				viewThumbnail={viewThumbnail}
				uploadUpdateThumbnail={uploadUpdateThumbnail}
				auctionName={auctionName}
			/>
			{imageSlideShow && (
				<ImageSlideModal
					closeImageSlideShow={imageSlideShowHandler}
					imageSlideArray={imageData}
					modalData={modalData}
				/>
			)}
			{(singleImageShow && singleImage !== "") && (
				<SingleImageModal
					closeImageSlideShow={viewThumbnail}
					imageUrl={singleImage}
					modalData={modalData}
				/>
			)}
			{imageUploadModal && (
				<ImageuploadModal
					closeImageModal={uploadUpdateImages}
					modalData={modalData}
					auth_token={loginResult?.access}
					multipleImageStatus={multipleImageStatus}
					auction_id={uplodedId}
				/>
			)}
		</Main>
	);
};

export default NbfcInventoryList;
